import { GTTRoute, GTTRouteStop } from 'gql/types.generated'

export enum IRouteDirection {
  OUTBOUND = 'outbound',
  INBOUND = 'inbound'
}

export enum IRouteType {
  PUBLIC = 'public',
  PRIVATE = 'private'
}

export interface IRouteStop {
  id: string
  name: string
  position: {
    lat: number
    lng: number
  }
}

export interface IRoute extends GTTRoute {
  origin: GTTRouteStop
  destination: GTTRouteStop
  intermediateStops: GTTRouteStop[]
}

export interface IRoutesResponse {
  total: number
  items: IRoute[]
}
